// @flow

export const RUN_RESULTS = {
  PENDING: "PENDING",
  PASSED: "PASSED",
  FAILED: "FAILED",
  STALE: "STALE",
};

export default RUN_RESULTS;
